// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__18J31","calendarButtons":"ClockData_calendarButtons__Zvn2g"};